const EXPENSE_PAYMENT_STATUS = Object.freeze({
  PENDING_PAYMENT: "PEP",
  PAID: "PAI",
  INVOICED: "INV",
});

const EXPENSE_PERIODICITY = Object.freeze({
  ALL: "ALL",
  CURRENT_YEAR: "CYE",
  PREVIOUS_YEAR: "PYE",
  CURRENT_MONTH: "CMO",
  PREVIOUS_MONTH: "PMO",
  CUSTOMISED: "CUS",
});

const EXPENSE_RECURRENCE = Object.freeze({
  PUNCTUAL: "PUN",
  MONTHLY: "MON",
  QUARTERLY: "QUA",
  HALF_YEARLY: "HAY",
  ANNUAL: "ANN",
});

export default {
  PAYMENT_STATUS: EXPENSE_PAYMENT_STATUS,
  PERIODICITY: EXPENSE_PERIODICITY,
  RECURRENCE: EXPENSE_RECURRENCE,
};
